import axios from 'axios'

export const baseUrls = ['https://api.ethplorer.io', 'https://kovan-api.ethplorer.io']
// const apikey = 'EK-hRGzv-H43VYyy-qQhWu'

export function getAddressInfo(address: string, chainId?: number) {
  const baseUrl = baseUrls[0]
  return axios.get(`${baseUrl}/getAddressInfo/${address}?apiKey=${process.env.REACT_APP_ETHPLORER_APIKEY}`)
}
